import apiClient from '../api-client';
import type { Appointment, CreateAppointmentRequest, UpdateAppointmentRequest, PaginatedResponse, PaginationParams } from '@geely/shared';

export interface AppointmentQueryParams {
  storeId?: string;
  storeIds?: string[];
  date?: string;
  dateFrom?: string;
  dateTo?: string;
  status?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const appointmentsApi = {
  list: (params?: AppointmentQueryParams) =>
    apiClient.get<Appointment[]>('/appointments', { params }),

  listPaginated: (params: AppointmentQueryParams & PaginationParams) =>
    apiClient.get<PaginatedResponse<Appointment>>('/appointments', { params }),

  getById: (id: string) =>
    apiClient.get<Appointment>(`/appointments/${id}`),

  create: (data: CreateAppointmentRequest) =>
    apiClient.post<Appointment>('/appointments', data),

  update: (id: string, data: UpdateAppointmentRequest) =>
    apiClient.patch<Appointment>(`/appointments/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/appointments/${id}`),
};
